import { render, staticRenderFns } from "./Bankverbindung.vue?vue&type=template&id=4d95ff02&"
import script from "./Bankverbindung.vue?vue&type=script&lang=js&"
export * from "./Bankverbindung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports